import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { SupportService } from '../../../services/support.service';
import { LocalStorageService } from '../../../services/local-storage.service';

@Component({
  selector: 'app-account-change-request',
  templateUrl: './account-change-request.component.html',
  styleUrls: ['./account-change-request.component.scss'],
})
export class AccountChangeRequestComponent {
  modalForm!: FormGroup;
  readonly MAX_FORM_LENGTH = 300;

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<AccountChangeRequestComponent>,
    private supportService: SupportService,
    private localStorageService: LocalStorageService,
  ) {
    const data = this.localStorageService.getAccountChangeRequest();
    this.modalForm = this.fb.group({
      request: [data, [Validators.required, Validators.maxLength(this.MAX_FORM_LENGTH)]]
    })
  }

  onCancel(): void {
    this.localStorageService.setAccountChangeRequest("");
    this.dialogRef.close();
  }

  get request() {
    return this.modalForm.get("request");
  }

  submitRequest(): void {
    this.supportService.createSupportRequest(this.request?.value).subscribe((response) => {
      console.log("Response from support service: ", response);
      this.dialogRef.close();
      this.localStorageService.setAccountChangeRequest("");
    });
  }

  onSave(): void {
    if (this.modalForm.invalid) {
      return;
    }
    this.localStorageService.setAccountChangeRequest(this.request?.value);
    this.dialogRef.close();
  }
}
